if (!customElements.get('custom-faq-section')) {
  class CustomFaqSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.items = Array.from(this.querySelectorAll('[data-faq-item]')).sort(
        (first, second) => Number(first.dataset.faqIndex) - Number(second.dataset.faqIndex)
      );

      if (this.classList.contains('custom-faq-section--has-image')) {
        const columns = this.querySelectorAll('.custom-faq-section__column');
        this.items.forEach((item) => columns[0]?.append(item));
        columns[1]?.remove();
      }

      this.loadMoreButton = this.querySelector('[data-faq-load-more]');
      this.itemsPerLoad = Math.max(1, Number.parseInt(this.dataset.itemsPerLoad, 10) || 1);
      this.visibleCount = Math.min(this.itemsPerLoad, this.items.length);

      this.items.forEach((item) => {
        const button = item.querySelector('.custom-faq-section__question');
        button?.addEventListener('click', () => this.toggleItem(item));
      });

      this.loadMoreButton?.addEventListener('click', () => this.loadMore());
      this.applyVisibleItems();

      const firstVisibleItem = this.items.find((item) => !item.classList.contains('is-load-hidden'));
      this.items.forEach((item) => this.setItemState(item, item === firstVisibleItem, false));

      this.resizeObserver = new ResizeObserver(() => this.updateOpenHeight());
      this.items.forEach((item) => {
        const answerInner = item.querySelector('.custom-faq-section__answer-inner');
        if (answerInner) this.resizeObserver.observe(answerInner);
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    applyVisibleItems() {
      this.items.forEach((item, index) => {
        const shouldHide = index >= this.visibleCount;
        item.classList.toggle('is-load-hidden', shouldHide);

        if (shouldHide && item.classList.contains('is-open')) {
          this.setItemState(item, false, false);
        }
      });

      if (this.loadMoreButton) {
        this.loadMoreButton.hidden = this.visibleCount >= this.items.length;
      }
    }

    loadMore() {
      this.visibleCount = Math.min(this.visibleCount + this.itemsPerLoad, this.items.length);
      this.applyVisibleItems();
    }

    toggleItem(selectedItem) {
      const shouldOpen = !selectedItem.classList.contains('is-open');

      this.items.forEach((item) => {
        if (item !== selectedItem && item.classList.contains('is-open')) {
          this.setItemState(item, false, true);
        }
      });

      this.setItemState(selectedItem, shouldOpen, true);
    }

    setItemState(item, open, animate) {
      const button = item.querySelector('.custom-faq-section__question');
      const answer = item.querySelector('.custom-faq-section__answer');
      if (!button || !answer) return;

      button.setAttribute('aria-expanded', String(open));
      answer.setAttribute('aria-hidden', String(!open));

      if (open) {
        item.classList.add('is-open');
        answer.style.height = `${answer.scrollHeight}px`;
        return;
      }

      if (animate && item.classList.contains('is-open')) {
        answer.style.height = `${answer.scrollHeight}px`;
        answer.getBoundingClientRect();
      }

      item.classList.remove('is-open');
      answer.style.height = '0px';
    }

    updateOpenHeight() {
      const openItem = this.items.find((item) => item.classList.contains('is-open'));
      const answer = openItem?.querySelector('.custom-faq-section__answer');
      if (answer) answer.style.height = `${answer.scrollHeight}px`;
    }
  }

  customElements.define('custom-faq-section', CustomFaqSection);
}
